import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IAllOpportunityAPIModel, IFilterItemModel,  IPaginationModel, ISortModel  } from '../models/IAllOpportunitiesModel';
import { GenericState } from './ISliceInterfaces';
import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS, FILTER_GROUP_NAMES  } from '../constants/constants';
 

export interface IFilterAPIModel {
  column: string,
  type: string,
  value: string | string[],
  groupName?: string,
  lookupStatus?:string[],
  displayValues?: string[]
}

export const initialState = {
  records: { status: 'idle' } as GenericState<IAllOpportunityAPIModel>,
  filter: [] as IFilterItemModel[],
  orphanFilters :[] as IFilterAPIModel[],
  sort: { columnName: null, orderBy: 'asc' } as ISortModel,
  pagination: { itemPerpage: 10, currentPage: 1 } as IPaginationModel,
  export: { loading: false }
};

/** Get All Opportunities */
export const getallOrphanOpportunities = createAsyncThunk('opportunities/getallOprhanOpportunities', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const roles: any = store.onBoarding && store.onBoarding.onBoardingData && store.onBoarding.onBoardingData.data && store.onBoarding.onBoardingData.data.roles;
  const activeRole: string = roles && roles.length > 0 ? roles[0] : '';
  const data = buildFilterRequest(store.orphan.orphanFilters, store.orphan.pagination, activeRole, store.orphan.sort,store.onBoarding.currentRole);
  const response = await axios.post<IAllOpportunityAPIModel>(OPPORTUNITIES_API_PATHS.opportunities, data);
  return response.data;
});


export const orphanSlice = createSlice({
  name: 'orphan',
  initialState,
  reducers: {
    addFilter: (state, action) => { 
      const data = action.payload;
      let updatedFilters = [...state.orphanFilters].filter((filter: any)=> filter.column !== data.column);
      const validData = [...updatedFilters, data].filter(el => el.value.length > 0);
      state.filter = validData;
      state.orphanFilters = validData;
    },
    clearAllFilters: (state, action) => {
      state.filter = [];
      state.orphanFilters =[];
    },
    removeMasterSearchFilter: (state, action) => {
      const searchRemoved = ([...state.filter]).filter((item, index) => FILTER_GROUP_NAMES.SEARCH !== item.groupName)
      state.filter = searchRemoved;
    },
    addSort: (state, action) => {
      const data = action.payload;
      state.sort.columnName = data.columnName;
      state.sort.orderBy = data.orderBy;
    },
    removeSort: (state) => {
      state.sort.columnName = null;
    },
    addOrphanFilters: (state, action) => {
      state.orphanFilters= action.payload;
    },
    setPaginationCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload
    },
    setPaginationItemPerPage: (state, action) => {
      state.pagination.itemPerpage= action.payload
    },
    setExportStatus: (state, action) => {
      state.export.loading = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getallOrphanOpportunities.pending, (state) => {
      state.records.status = 'loading';
    });
    builder.addCase(getallOrphanOpportunities.fulfilled, (state, action) => {
      state.records.status = 'finished';
      state.records.data = action.payload;
    });
    builder.addCase(getallOrphanOpportunities.rejected, (state) => {
      state.records.status = 'error';
    });
  }
});

export const { addFilter, addSort, removeSort, clearAllFilters, setPaginationCurrentPage, setPaginationItemPerPage, setExportStatus, removeMasterSearchFilter ,addOrphanFilters} = orphanSlice.actions;

export const getAllOrphanOpportunitiesSelector = (state: RootState) => state.orphan.records;

export const getOrphanFiltersSelector = (state: RootState) => state.orphan.orphanFilters;

export const getSortOrphanSelector = (state: RootState) => state.orphan.sort;

export const getFiltersSelector = (state: RootState) => state.orphan.filter;

export const getOrphanPaginationSelector = (state: RootState) => state.orphan.pagination;

export default orphanSlice.reducer;


export const buildFilterRequest = (filters: IFilterItemModel[], pagination: IPaginationModel, role: string, sortData: ISortModel,currentRole:string) => {
  let data= { "page": pagination.currentPage > 0 ? pagination.currentPage : 1, "rows_per_page": pagination.itemPerpage, sort: {}, "filters": [] as IFilterItemModel[],"orphan":true ,"current_role":currentRole}
  
  data.filters = [...filters];
  if (sortData.columnName) {
    data.sort = sortData;
  }
  return data;
}

